import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigation } from '../contexts/NavigationContext';
import { IconHome, IconUsers, IconFileText, IconDollarSign } from '../components/Icons';

const HomeView = () => {
  const { t } = useLanguage();
  const { navigateTo } = useNavigation();

  const benefits = [
    {
      title: t('efficiencyForLandlords'),
      description: t('efficiencyForLandlordsDesc'),
      icon: IconHome,
      color: 'bg-blue-500',
    },
    {
      title: t('convenienceForTenants'),
      description: t('convenienceForTenantsDesc'),
      icon: IconUsers,
      color: 'bg-green-500',
    },
    {
      title: t('integratedSystem'),
      description: t('integratedSystemDesc'),
      icon: IconFileText,
      color: 'bg-purple-500',
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div 
        className="relative h-96 bg-cover bg-center"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1973&q=80")',
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50" />
        <div className="relative h-full flex items-center justify-center text-center px-4">
          <div>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
              {t('heroTitle')}
            </h1>
            <p className="text-xl md:text-2xl text-white mb-8">
              {t('heroSubtitle')}
            </p>
            <button
              onClick={() => navigateTo('propertyPromotion')}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors"
            >
              {t('learnMore')}
            </button>
          </div>
        </div>
      </div>

      {/* Platform Overview */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t('platformOverview')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('platformOverviewText')}
          </p>
        </div>

        {/* Key Benefits */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">
            {t('keyBenefits')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow"
              >
                <div className={`${benefit.color} w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto`}>
                  <benefit.icon className="w-8 h-8 text-white" />
                </div>
                <h4 className="text-xl font-semibold text-gray-900 text-center mb-3">
                  {benefit.title}
                </h4>
                <p className="text-gray-600 text-center">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeView;
